/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_ANNOUNCEMENT_URL, COMMON_HEADER_CONFIG} from "../config";

class LanguageSettingService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchLanguageSettings = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/language-info`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getLanguageSettings = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/language-info`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createLanguageSetting = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ANNOUNCEMENT_URL}/language-info`,
        data: dataCreate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateLanguageSetting = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_ANNOUNCEMENT_URL}/language-info`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getLanguageSetting = (key) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/language-info/${key}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteLanguageSetting = (key, platform_key) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_ANNOUNCEMENT_URL}/language-info`,
        data: {key, platform_key},
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.message) {
            resolve(response.data.message);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const languageSettingService = new LanguageSettingService();

export default languageSettingService;
